import React from 'react';
import { Skeleton, Space } from 'antd';
import styles from './CheckoutDrawerSkeleton.module.css';

/**
 * Skeleton loading component for CheckoutDrawer
 * Mimics the structure of StripeCheckoutForm while loading
 * @returns React.JSX.Element
 */
const CheckoutDrawerSkeleton = () => {
  return (
    <div className={styles.Container}>
      {/* Scrollable content */}
      <div className={styles.ScrollableContent}>
        {/* Price Info Section Skeleton */}
        <div className={styles.PriceInfoSection}>
          {/* Product title skeleton */}
          <Skeleton.Input 
            active 
            size="large" 
            style={{ width: '60%', height: '28px', marginBottom: '12px' }} 
          />
          
          {/* Product description skeleton */}
          <Skeleton 
            active 
            paragraph={{ rows: 2, width: ['100%', '80%'] }} 
            title={false}
            className={styles.DescriptionSkeleton}
          />
          
          {/* Price skeleton */}
          <Skeleton.Input 
            active 
            size="default" 
            style={{ width: '40%', height: '24px', marginTop: '8px' }} 
          />
        </div>

        {/* Payment Methods Section Skeleton */}
        <div className={styles.PaymentMethodsSection}>
          <Skeleton.Input 
            active 
            size="default" 
            style={{ width: '80px', height: '20px', marginBottom: '16px' }} 
          />
          
          {/* Radio options skeleton */}
          <Space direction="vertical" size="small" style={{ width: '100%' }}>
            <div className={styles.RadioOptionSkeleton}>
              <div className={styles.RadioCircle} />
              <Skeleton.Input active size="small" style={{ width: '220px', height: '16px' }} />
            </div>
            <div className={styles.RadioOptionSkeleton}>
              <div className={styles.RadioCircleSelected} />
              <Skeleton.Input active size="small" style={{ width: '180px', height: '16px' }} />
            </div>
          </Space>
        </div>

        {/* Billing Address Section Skeleton */}
        <div className={styles.BillingAddressSection}>
          <Skeleton.Input 
            active 
            size="small" 
            style={{ width: '100px', height: '16px', marginBottom: '16px' }} 
          />
          
          {/* Full name field */}
          <div className={styles.FormField}>
            <Skeleton.Input 
              active 
              size="small" 
              style={{ width: '70px', height: '14px', marginBottom: '8px' }} 
            />
          </div>

          {/* Country dropdown field */}
          <div className={styles.FormField}>
            <Skeleton.Input 
              active 
              size="small" 
              style={{ width: '120px', height: '14px', marginBottom: '8px' }} 
            />
            <div className={styles.DropdownSkeleton}>
              <Skeleton.Input active size="default" style={{ width: '80px', height: '16px' }} />
              <div className={styles.DropdownArrow} />
            </div>
          </div>

          {/* Address field */}
          <div className={styles.FormField}>
            <Skeleton.Input 
              active 
              size="small" 
              style={{ width: '60px', height: '14px', marginBottom: '8px' }} 
            />
            <Skeleton.Input 
              active 
              size="default" 
              style={{ width: '100%', height: '40px' }} 
            />
          </div>
        </div>
      </div>

      {/* Fixed footer with button skeletons */}
      <div className={styles.FixedFooter}>
        <Space className={styles.FooterButtonContainer}>
          <Skeleton.Button active size="large" style={{ width: '80px' }} />
          <Skeleton.Button active size="large" style={{ width: '100px' }} />
        </Space>
      </div>
    </div>
  );
};

export default CheckoutDrawerSkeleton;
